import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

const SuccessModal = ({ onClose, title = "Thank You!", message = "Your submission has been received.", subMessage = "We will get back to you shortly." }) => {

    // Auto-dismiss logic inside the component to keep it self-contained if desired, 
    // but the parent usually controls visibility state. 
    // The previous implementation had the parent control the timeout.
    // I will keep the timeout control in the parent to avoid complexity with unmounting, 
    // OR I can put it here. Putting it here is cleaner for "auto-dismissing modal".

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-50 backdrop-blur-sm animate-fade-in">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center transform transition-all scale-100 border-t-4 border-[#008080]">
                <div className="flex items-center justify-center mb-6">
                    <div className="bg-teal-50 p-4 rounded-full">
                        <CheckCircle className="w-12 h-12 text-[#008080]" />
                    </div>
                </div>
                <h4 className="font-serif text-3xl text-[#D99C3B] mb-3">{title}</h4>
                <p className="text-xl text-gray-800 font-medium mb-2">{message}</p>
                <p className="text-gray-500 mb-8">{subMessage}</p>

                <button
                    onClick={onClose}
                    className="w-full py-3 px-6 bg-[#008080] text-white font-bold rounded-lg hover:bg-teal-700 transition-colors uppercase tracking-wide"
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default SuccessModal;
